import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {ICopierRow} from '../copier/copiers'
import {ILeaderProfit} from './getLeader'

// admin/copy/leader/:id 응답. 백엔드 copyLeaderDetailResp(copyLeaderRow + 아래 필드)와 1:1.
// v1 시절 타입에 있던 bot_link / is_active / is_bot / access_key / Summary / open_orders 등은
// 실제 응답에 없어 제거했다(자산·포지션도 이 응답에는 없다).
export interface ILeaderDetail {
    id: string
    user_id: string
    copy_lead_name: string
    exchange: string
    copier: number
    max_copier: number
    mdd: number
    risk: number
    tpd: number
    win: number
    loss: number
    allow_copy: boolean
    created_at: number // unix 초
    user_name: string
    user_thumbnail: string
    all_time_profit: number
    profit?: ILeaderProfit
    account_id: string
    min_balance: number
    lead_start_date?: string | null // RFC3339 문자열
    leader?: {id: string; name: string; thumbnail: string}
    copiers?: ICopierRow[] // bot_score만 채워져 온다(bot은 없음)
}

export const getLeaderDetail = async (id: string): Promise<ApiRes<ILeaderDetail>> => {
    return await apiGet(API_URL, `admin/copy/leader/${id}`)
}
